import React from 'react';
import PropTypes from 'prop-types';

import TableHeader from './tableHeader';
import TableBody from './tableBody';
import Pagination from './pagination';

const Table = ({
  title = '',
  header,
  data,
  actions = () => {},
  dataModel = {},
  currentPage = 1,
  step = 100,
  count = 0,
  url = '',
  callback = () => {},
  setPage
}) => {
  const keys = Object.keys(header);
  let heading = `${title}`;
  if (title && count) heading += ` (${count})`;
  return (
    <div className="responsive-table-container">
      <table className="responsive-table">
        <caption className="responsive-table__caption">{heading}</caption>
        <TableHeader keys={keys} data={header} />
        <TableBody
          keys={keys}
          data={data}
          actions={actions}
          dataModel={dataModel}
          currentPage={currentPage}
          step={step}
          callback={callback}
          header={Object.values(header)}
        />
      </table>
      <Pagination
        setPage={setPage}
        currentPage={currentPage}
        step={step}
        count={count}
        url={url}
      />
    </div>
  );
};

Table.propTypes = {
  title: PropTypes.string,
  header: PropTypes.objectOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  actions: PropTypes.func,
  defaultSort: PropTypes.shape({
    index: PropTypes.string,
    dir: PropTypes.bool
  }),
  dataModel: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  currentPage: PropTypes.number,
  step: PropTypes.number,
  count: PropTypes.number,
  url: PropTypes.string,
  callback: PropTypes.func,
  setPage: PropTypes.func.isRequired
};

export default Table;
